import { useMutation, useQueryClient } from '@tanstack/react-query';
import { expensesKeys } from 'store/expenses';
import { converters as filesConverters } from 'store/files';
import { loaders } from './employees.loaders';
import { employeesKeys } from './employees.queries';

export const useCreateEmployee = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createEmployee, {
    onSuccess: () => {
      queryClient.invalidateQueries(employeesKeys.lists);
    },
  });
};

export const useUpdateEmployee = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateEmployee, {
    onSuccess: () => {
      queryClient.invalidateQueries(employeesKeys.all);
    },
  });
};

export const useBulkUpdateEmployees = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.bulkUpdateEmployees, {
    onSuccess: () => {
      queryClient.invalidateQueries(employeesKeys.all);
    },
  });
};

export const useSendInvitations = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.sendInvitations, {
    onSuccess: () => {
      queryClient.invalidateQueries(employeesKeys.all);
    },
  });
};

export const useDeleteEmployee = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.deleteEmployee, {
    onSuccess: () => {
      queryClient.invalidateQueries(employeesKeys.lists);
    },
  });
};

export const useCreateEmployeeExpense = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createExpense, {
    onSuccess: (_, { employeeId }) => {
      queryClient.invalidateQueries(employeesKeys.detail(employeeId));
      queryClient.invalidateQueries(expensesKeys.lists);
    },
  });
};

export const useUnlinkEmployee = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.unlinkEmployee, {
    onSuccess: () => {
      queryClient.invalidateQueries(employeesKeys.all);
    },
  });
};

export const useExportToXls = () => {
  return useMutation(loaders.exportXls, {
    onSuccess: filesConverters.export,
  });
};

export const useExportEmployeeBlueprint = () => {
  return useMutation(loaders.exportEmployeeBlueprint, {
    onSuccess: filesConverters.export,
  });
};

export const useImportEmployeeConsents = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.importConsents, {
    onSuccess: () => {
      queryClient.invalidateQueries(employeesKeys.all);
    },
  });
};

export const useExportEmployeeConsents = () => {
  return useMutation(loaders.exportConsents, {
    onSuccess: filesConverters.export,
  });
};

export const usePrepareEmployeeBlueprint = () => {
  return useMutation(loaders.prepareEmployeeBlueprint);
};

export const useImportEmployeeBlueprint = () => {
  return useMutation(loaders.importEmployeeBlueprint);
};

export const useExportOrgStructureEmployees = () => {
  return useMutation(loaders.exportOrgStructureEmployees);
};

export const useExportCompanyOrgStructure = () => {
  return useMutation(loaders.exportCompanyOrgStructure);
};

export const useImportOrgStructure = () => {
  return useMutation(loaders.importOrgStructure);
};
